import AxiosInstance from "./api";

export const ContractForWorkService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/contract-for-work", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get("/private/contract-for-work/" + id);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/contract-for-work", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/contract-for-work/" + id, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete("/private/contract-for-work/" + id);
  },
};
